module.exports = __webpack_public_path__ + "static/media/flax.2ddea8d0.jpg";